import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingAgrementDateTitleFR: {
    id: 'charity.vetting.fr.agrement.date.title',
    defaultMessage: 'What is the date of your "agrément"?',
  },
  charityVettingAgrementDateLabelFR: {
    id: 'charity.vetting.fr.agrement.date.label',
    defaultMessage: 'Date of "agrément"',
  },
  charityVettingAgrementDatePlaceholderFR: {
    id: 'charity.vetting.fr.agrement.date.placeholder',
    defaultMessage: 'Choose the date',
  },
  charityVettingAgrementDateRequiredFR: {
    id: 'charity.vetting.fr.agrement.date.required',
    defaultMessage: 'Please provide the date of your "agrément"',
  },
});
